import React from 'react';
import { Chip, Grid } from '@mui/material';
import { GridColDef } from '@mui/x-data-grid';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { usePagedList } from '../../../hooks/use-paged-list';
import { formatDateTime } from '../../../utils/date';
import { useCustomPageSearchController } from './context/custom-page-search-controller';
import { useCustomPageSearchState } from './context/custom-page-search-context';
import CustomPageAppService from '../../../application/platform/apm/custom-page/custom-page-app-service';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { PUBLICATION_STATUS_OPTIONS, booleanFilterValue } from '../../../utils/filter-options';
import { PagedGrid } from '../../../components/paged-grid';
import { DeleteAction, EditAction } from '../../../components/row-actions';

export function CustomPageSearchComponent() {
    const ctrl = useCustomPageSearchController();
    const { parameters, searchTrigger } = useCustomPageSearchState();
    const list = usePagedList(CustomPageAppService.list, parameters, searchTrigger, 'Não foi possível carregar as páginas');

    const columns: GridColDef[] = [
        { field: 'id', headerName: 'ID', width: 80 },
        { field: 'title', headerName: 'Título', flex: 1, minWidth: 220 },
        { field: 'slug', headerName: 'Endereço', flex: 1, minWidth: 180, valueFormatter: (params) => (params.value ? `/${params.value}` : '') },
        {
            field: 'isPublished', headerName: 'Situação', width: 120,
            renderCell: (params) => <Chip size="small" color={params.value ? 'success' : 'default'} label={params.value ? 'Publicada' : 'Rascunho'} />
        },
        { field: 'publishedAt', headerName: 'Publicada em', width: 150, valueFormatter: (params) => formatDateTime(params.value) },
        { field: 'updatedAt', headerName: 'Alterada em', width: 150, valueGetter: (params) => params.row.updatedAt || params.row.createdAt, valueFormatter: (params) => formatDateTime(params.value) },
        {
            field: 'actions', headerName: 'Ações', width: 100, sortable: false,
            renderCell: (params) => (
                <React.Fragment>
                    <EditAction onClick={() => ctrl.navigateToEdit(params.row.id)} />
                    <DeleteAction onClick={() => ctrl.handleDelete(params.row)} />
                </React.Fragment>
            )
        }
    ];

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Páginas Customizadas"
                    subtitle="Crie e publique páginas institucionais do portal"
                    breadcrumbs={[{ label: 'Páginas Customizadas' }]}
                />
            </Grid>
            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={8}>
                        <FilterInput label="Título ou endereço" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <FilterSelect
                            label="Situação"
                            name="select-status"
                            value={booleanFilterValue(parameters.isPublished)}
                            options={PUBLICATION_STATUS_OPTIONS}
                            emptyLabel="Todas"
                            onChange={ctrl.handleOnChange}
                        />
                    </Grid>
                </FilterPanel>
            </Grid>
            <Grid item xs={12}>
                <PagedGrid
                    columns={columns}
                    list={list}
                    parameters={parameters}
                    onPaginationChange={ctrl.handlePaginationChange}
                    addLabel="Nova Página"
                    onAdd={ctrl.navigateToCreate}
                />
            </Grid>
        </React.Fragment>
    );
}
